import { OktaAuth } from '@okta/okta-auth-js';
import oktaConfig from './oktaConfig';

const oktaAuthentication = new OktaAuth({
    clientId: oktaConfig.clientId,
    issuer: oktaConfig.issuer,
    redirectUri: oktaConfig.redirectUri,
    scopes: oktaConfig.scopes,
    pkce: oktaConfig.pkce
});

export default oktaAuthentication;